<template>
  <div>
    <el-button
      type="primary"
      size="medium"
      :disabled="!appCode"
      @click="showDialog = true"
      >Import users</el-button
    >
    <el-dialog :title="'Import Users'" :visible.sync="showDialog" width="30%">
      <div
        v-if="loading"
        v-loading="loading"
        :style="{ height: '100px' }"
      ></div>
      <template v-else>
        <div class="note">
          <p>
            We have provided a csv template for you to download. <br />
            Download the template and fill the required information, then upload
            the updated CSV.
          </p>
          <span>Note - Do not change template headers </span>
        </div>
        <span slot="footer">
          <el-button
            type="primary"
            outline
            size="small"
            @click="downloadTemplate"
            :loading="downloading"
            >Download</el-button
          >
          <el-button
            class="ml-1"
            type="primary"
            plain
            size="small"
            @click="upload"
            >Upload</el-button
          >
        </span>
      </template>
    </el-dialog>
    <ra-csv-upload
      :title="'User Importation - CSV Upload'"
      :show.sync="showUpload"
      :uploading.sync="uploading"
      @upload="uploadUsers"
    />
  </div>
</template>

<script>
import { generateCSV } from "./import-config";
import apiConstants from "@/apiConstants";

export default {
  name: "ImportUsers",
  props: {
    appName: {
      type: String,
      default: ""
    },
    appCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      data: {
        title: "",
        fileName: "Template",
        data: [{}]
      },
      downloading: false,
      showUpload: false,
      uploading: false
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },

  watch: {
    appName() {
      this.data.title = `${this.appName}_Users_Template`;
      this.data.fileName = `${this.appName}_Users_Template`;
    }
  },

  methods: {
    downloadTemplate() {
      this.downloading = true;
      const apiUrl = `apps/${this.appCode}/users/import/templates`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.downloading = false;
          } else {
            const { column_headers } = resData;
            column_headers.forEach(header => {
              this.data.data[0][header] = "";
            });
            this.download();
          }
        })
        .catch(() => {
          this.notification(
            "Error",
            "Unable to download template. An unknown error occurred",
            "danger"
          );
          this.downloading = false;
        });
    },
    download() {
      setTimeout(() => {
        generateCSV({ ...this.data });
        this.downloading = false;
      }, 1000);
    },

    upload() {
      this.showDialog = false;
      this.showUpload = true;
    },

    uploadUsers(file) {
      this.uploading = true;
      const formData = new FormData();
      formData.append("file", file);

      const apiUrl = `apps/${this.appCode}/users/import/batches`;
      this.$http
        .post(apiUrl, formData, {
          headers: {
            "data-baseurl-namespace": apiConstants.URLS.AUTHX,
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.uploading = false;
          } else {
            this.uploading = false;
            this.showUpload = false;
            setTimeout(() => {
              this.$emit("imported");
            }, 2000);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.uploading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.note {
  p {
    color: var(--ra-grey-tertiary);
    margin-bottom: 20px;
  }

  span {
    color: var(--ra-grey-primary);
    font-size: 0.875rem;
    font-weight: 500;
  }
}
</style>
